var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container postage-recharge-detail" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleBack } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-download",
                        disabled: !_vm.fileName,
                      },
                      on: { click: _vm.downloadFile },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("downloadText")) + " ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" " + _vm._s(_vm.$t("billingPage.PostageRecharge")) + " ")]
      ),
      _c(
        "el-row",
        { staticClass: "detail-overview", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "detail-overview__col", attrs: { span: 16 } },
            [
              _c("div", { staticClass: "overview-card" }, [
                _c("div", { staticClass: "overview-card__meta" }, [
                  _vm._v(
                    _vm._s(_vm.$t("billingPage.PostageRechargeInvoiceOverview"))
                  ),
                ]),
                _c("div", { staticClass: "overview-card__title" }, [
                  _vm._v(_vm._s(_vm.detail.invoiceNumber || _vm.invoiceNumber)),
                ]),
                _c("div", { staticClass: "overview-card__sub" }, [
                  _c("span", [_vm._v(_vm._s(_vm.logisticsCompany))]),
                ]),
                _c(
                  "div",
                  { staticClass: "overview-metrics" },
                  _vm._l(_vm.overviewMetrics, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.key,
                        staticClass: "overview-metrics__item",
                        class: item.className,
                      },
                      [
                        _c("span", [_vm._v(_vm._s(item.label))]),
                        _c("strong", [_vm._v(_vm._s(item.value))]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _c(
            "el-col",
            { staticClass: "detail-overview__col", attrs: { span: 8 } },
            [
              _c(
                "div",
                { staticClass: "reason-card" },
                [
                  _c("div", { staticClass: "reason-card__label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("billingPage.PostageRechargeUnmatchedAmount")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "reason-card__amount" }, [
                    _vm._v(_vm._s(_vm.formatMoney(_vm.detail.unmatchedAmount))),
                  ]),
                  _c(
                    "el-form",
                    { attrs: { "label-position": "top" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "billingPage.PostageRechargeUnmatchedReason"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              placeholder: _vm.$t(
                                "billingPage.PostageRechargeReasonPlaceholder"
                              ),
                            },
                            model: {
                              value: _vm.unmatchedReason,
                              callback: function ($$v) {
                                _vm.unmatchedReason = $$v
                              },
                              expression: "unmatchedReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        loading: _vm.reasonSaving,
                      },
                      on: { click: _vm.saveReason },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("billingPage.PostageRechargeSaveReason")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          " " + _vm._s(_vm.$t("billingPage.PostageRechargeMatchedOrders")) + " "
        ),
        _c("span", { staticClass: "divider-count" }, [
          _vm._v("(" + _vm._s(_vm.filteredMatchedRows.length) + ")"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-filter" },
        [
          _c("el-input", {
            staticClass: "table-filter__input",
            attrs: {
              clearable: "",
              "prefix-icon": "el-icon-search",
              placeholder: _vm.$t(
                "billingPage.PostageRechargeSearchOrderPlaceholder"
              ),
            },
            on: { input: _vm.handleMatchedSearch },
            model: {
              value: _vm.matchedSearchKeyword,
              callback: function ($$v) {
                _vm.matchedSearchKeyword =
                  typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "matchedSearchKeyword",
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.matchedPagedRows,
            border: "",
            "max-height": "480px",
            "cell-class-name": _vm.getMatchedCellClass,
          },
          on: { "sort-change": _vm.handleMatchedSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "orderNumber",
              label: _vm.$t("billingPage.PostageRechargeOrderNumber"),
              fixed: "left",
              align: "center",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "copy-value",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.copyValue(scope.row.orderNumber)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(scope.row.orderNumber) + " "),
                        _c("i", { staticClass: "el-icon-copy-document" }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "trackingNumber",
              label: _vm.$t("billingPage.PostageRechargeTrackingNumber"),
              fixed: "left",
              align: "center",
              "min-width": "170",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "copy-value",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.copyValue(scope.row.trackingNumber)
                          },
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(scope.row.trackingNumber) + " "),
                        _c("i", { staticClass: "el-icon-copy-document" }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.matchedAmountColumns, function (column) {
            return _c("el-table-column", {
              key: column.prop,
              attrs: {
                prop: column.prop,
                "min-width": column.width,
                align: "center",
                sortable: "custom",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("span", [_vm._v(_vm._s(column.label))]),
                        column.formula
                          ? _c(
                              "el-tooltip",
                              { attrs: { effect: "dark", placement: "top" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "formula-tooltip",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.formulaDefinitions[
                                              column.formula
                                            ].labelKey
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.formulaDefinitions[
                                              column.formula
                                            ].descriptionKey
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.formulaDefinitions[
                                              column.formula
                                            ].formulaKey
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-info formula-info",
                                  attrs: { tabindex: "0" },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        column.prop === "currentChargeAmount"
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom-end",
                                  width: "320",
                                  trigger: "click",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "calculation-breakdown" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "calculation-breakdown__title",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "billingPage.PostageRechargeCalculationBreakdown"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "calculation-breakdown__row",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "billingPage.PostageRechargeCurrentDifference"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMoney(
                                                scope.row.currentDifference
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "calculation-breakdown__row",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "billingPage.PostageRechargeProfitMargin"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatPercent(
                                                scope.row.profitMargin
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "calculation-breakdown__result",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "billingPage.PostageRechargeCurrentChargeAmount"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMoney(
                                                scope.row.currentChargeAmount
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "amount-button",
                                    attrs: {
                                      slot: "reference",
                                      type: "button",
                                    },
                                    on: {
                                      mouseenter: function ($event) {
                                        return _vm.setActiveFormula(
                                          scope.row,
                                          column.prop
                                        )
                                      },
                                      mouseleave: _vm.clearActiveFormula,
                                      focus: function ($event) {
                                        return _vm.setActiveFormula(
                                          scope.row,
                                          column.prop
                                        )
                                      },
                                      blur: _vm.clearActiveFormula,
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatMoney(
                                            scope.row[column.prop]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "detail-amount",
                                on: {
                                  mouseenter: function ($event) {
                                    column.formula &&
                                      _vm.setActiveFormula(
                                        scope.row,
                                        column.prop
                                      )
                                  },
                                  mouseleave: function ($event) {
                                    column.formula && _vm.clearActiveFormula()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatMoney(scope.row[column.prop])
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              prop: "profitMargin",
              "min-width": "130",
              align: "center",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("billingPage.PostageRechargeProfitMargin")
                        )
                      ),
                    ]),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "dark", placement: "top" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "formula-tooltip",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.formulaDefinitions.profitMargin.labelKey
                                  )
                                )
                              ),
                            ]),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.formulaDefinitions.profitMargin
                                      .descriptionKey
                                  )
                                )
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.formulaDefinitions.profitMargin
                                      .formulaKey
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("i", {
                          staticClass: "el-icon-info formula-info",
                          attrs: { tabindex: "0" },
                        }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "detail-amount",
                        on: {
                          mouseenter: function ($event) {
                            return _vm.setActiveFormula(
                              scope.row,
                              "profitMargin"
                            )
                          },
                          mouseleave: _vm.clearActiveFormula,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatPercent(scope.row.profitMargin)) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.operationText"),
              fixed: "right",
              align: "center",
              width: "90",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.showOrderInfo(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _vm.filteredMatchedRows.length
        ? _c("pagination", {
            staticClass: "table-pagination",
            attrs: {
              total: _vm.filteredMatchedRows.length,
              page: _vm.matchedPage,
              limit: _vm.matchedPageSize,
              "page-sizes": _vm.pageSizes,
              "auto-scroll": false,
            },
            on: {
              "update:page": function ($event) {
                _vm.matchedPage = $event
              },
              "update:limit": function ($event) {
                _vm.matchedPageSize = $event
              },
              pagination: _vm.handleMatchedPagination,
            },
          })
        : _vm._e(),
      _c("BjDivider", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("billingPage.PostageRechargeUnmatchedItems")) +
            " "
        ),
        _c("span", { staticClass: "divider-count is-danger" }, [
          _vm._v("(" + _vm._s(_vm.unmatchedRows.length) + ")"),
        ]),
      ]),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.unmatchedPagedRows,
            border: "",
            "max-height": "420px",
          },
          on: { "sort-change": _vm.handleUnmatchedSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "consignmentNum",
              label: _vm.$t("billingPage.consignmentNum"),
              align: "center",
              "min-width": "170",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invoicePrice",
              label: _vm.$t("billingPage.PostageRechargeInvoicePrice"),
              align: "center",
              "min-width": "130",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm.formatMoney(scope.row.invoicePrice))),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "originalCsvRawData",
              label: _vm.$t("billingPage.PostageRechargeRawData"),
              align: "center",
              "min-width": "360",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "raw-data-cell",
                        attrs: {
                          title: _vm.formatRawData(_vm.getRawData(scope.row)),
                        },
                        on: {
                          click: function ($event) {
                            _vm.copyRawData(_vm.getRawData(scope.row))
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatRawData(_vm.getRawData(scope.row))
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.operationText"),
              align: "center",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    String(scope.row.canManualMatch) === "1"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openManualMatch(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "billingPage.PostageRechargeManualMatch"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.unmatchedRows.length
        ? _c("pagination", {
            staticClass: "table-pagination",
            attrs: {
              total: _vm.unmatchedRows.length,
              page: _vm.unmatchedPage,
              limit: _vm.unmatchedPageSize,
              "page-sizes": _vm.pageSizes,
              "auto-scroll": false,
            },
            on: {
              "update:page": function ($event) {
                _vm.unmatchedPage = $event
              },
              "update:limit": function ($event) {
                _vm.unmatchedPageSize = $event
              },
              pagination: _vm.handleUnmatchedPagination,
            },
          })
        : _vm._e(),
      _c("ManualMatchDialog", {
        ref: "ManualMatchDialog",
        on: { matched: _vm.getData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }